const emails=[""]
export const checkPermission = (permission) => {

    const 
    permissions = JSON.parse(localStorage.getItem("user_info"))?.permissions ?? []
    const is_admin = JSON.parse(localStorage.getItem("user_info"))?.is_admin ?? false
    if (is_admin) {
        return true
    }
    else if (permissions.some(elelment => permission.includes(elelment))) {
        return true
    } else {
        return false
    }
}



